import React from 'react';

import { useLocale, useTranslations } from 'next-intl';
import styled from 'styled-components';

import { Format } from '@/lib/dateTime/formatDate';
import { log } from '@/utils/logger';

const Time = styled.time`
  color: #000;
  font-family: 'Atlas Grotesk';
  font-size: 0.75rem;
  font-style: normal;
  font-weight: 300;
  line-height: normal;
`;

export default function RelativeDate({ date: dateString, dateOnly = false }) {
  const locale = useLocale();
  const t = useTranslations();
  const [relativeDate, dateIsoString] = React.useMemo(() => {
    const date = new Format(dateString);
    const relativeDate = date.in(locale).toRelativeTime();
    const dateIsoString = date.toIsoString();
    return [relativeDate, dateIsoString];
  }, [dateString]);

  if (!dateString) {
    log.error('RelativeDate: date is missing');
    return null;
  }

  if (dateOnly) {
    return <Time dateTime={dateIsoString}>{relativeDate}</Time>;
  }

  return (
    <Time dateTime={dateIsoString}>
      {t('last-updated')} {relativeDate}
    </Time>
  );
}
